import { Directive, Injectable } from '@angular/core';
import { MetabaseApiService, MetabaseCardCollection } from './metabase-report-api.service';
import { ApiService, IApiOption } from '@red/api';
import { Mixin } from 'ts-mixer';
import { IQuerySearch } from '@shared/data-access/interfaces';
import { Observable, map } from 'rxjs';
import { PaginationAdapter } from '@red/data-access';
import { ReportCard } from '@shared/components/report-manager';
import { ExceljsApiService, ExceljsCardCollection } from './exceljs-report-api.service';


@Directive()
abstract class AwardsReportExceljsApiService extends ExceljsApiService {
  collectionEndpoint = ExceljsCardCollection.AwardsReport;
}
@Directive()
abstract class AwardsReportCardApiService {
  static REPORT_CARD_POINT = 'hrm/hr/reports-awards';
  constructor(protected apiService: ApiService) { }

  findReportCards(query: IQuerySearch = {}, option?: IApiOption): Observable<PaginationAdapter<ReportCard>> {
    return this.apiService.get(AwardsReportCardApiService.REPORT_CARD_POINT, query, option).pipe(map(data => new PaginationAdapter(ReportCard, data)));
  }
}

@Injectable({
  providedIn: 'root',
})
export class AwardsReportApiService extends Mixin(AwardsReportCardApiService, AwardsReportExceljsApiService) { }
